import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DashboardIcon from '@material-ui/icons/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import BarChartIcon from '@material-ui/icons/BarChart';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import {
  Link
} from "react-router-dom";

export const mainListItems = (
  <div>
    <ListItem button
    component={Link} to="../dashboard/profile"
    selected
    >
    <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
    
      <ListItemText primary="Dashboard" />
    
    </ListItem>
  

    <ListItem button component={Link} to="../marketwatch"
>
      <ListItemIcon>
        <BarChartIcon />
      </ListItemIcon>
      <ListItemText primary="Market" />

    </ListItem>

  </div>
);

export const secondaryListItems = (
  <div>
    <ListSubheader inset>Links</ListSubheader>
    <ListItem button component={Link} to="../dashboard/orders">
      <ListItemIcon>
        <InventoryIcon />
      </ListItemIcon>
      <ListItemText primary="Orders" />
    </ListItem>
    <ListItem button component={Link} to="../dashboard/holdings">
      <ListItemIcon>
        <ShowChartIcon />
      </ListItemIcon>
      <ListItemText primary="Portfolio" />
    </ListItem>
    <ListItem button component={Link} to="../dashboard/gifts">
        <ListItemIcon>
        <CardGiftcardIcon/>
      </ListItemIcon>
      <ListItemText primary="Gifts" />
    </ListItem>
    <ListItem button component={Link} to="../dashboard/support">
        <ListItemIcon>
        <SupportAgentIcon/>
      </ListItemIcon>
      <ListItemText primary="Support" />
    </ListItem>
    <ListItem button component={Link} to="../dashboard/news">
      <ListItemIcon>
        <NewspaperIcon />
      </ListItemIcon>
      <ListItemText primary="News" />
    </ListItem>
  </div>
);
